import React, {PureComponent, Fragment} from "react"

import Loading from "@irati/ui/src/Loading"
import {FormattedMessage} from "@irati/utils/lang"
import getId from "@irati/utils/id"
import DateGroupedStatementItems from "@irati/wallet/types/DateGroupedStatementItems"

import DateHeader from "./DateHeader"
import {StatementItem, Hr, ShowMoreButton} from "./styled"

interface Props {
  results: DateGroupedStatementItems[]
  paginationCount: number
  onShowMoreClick(): void
  canLoadMore: boolean
  load: Promise<void> | null
  id: string
  cursor: string | null
}

export default class StatementItemDetail extends PureComponent<Props> {
  render() {
    const {results, paginationCount, onShowMoreClick, load, canLoadMore, cursor, id} = this.props

    return (
      <>
        {results.map(({date, data}) => {
          const key = date.format("YYYY-MM-DD")
          return (
            <Fragment key={key}>
              <Hr />
              <DateHeader id={getId(`date-header_${key}`, id)} date={date} />
              {data.map((statementItem) => (
                <StatementItem
                  id={getId(`statement-item_${statementItem.uuid}`, id)}
                  statementItem={statementItem}
                  key={statementItem.uuid}
                />
              ))}
            </Fragment>
          )
        })}
        <Loading load={load} />
        {canLoadMore && cursor && (
          <ShowMoreButton id={id} onClick={onShowMoreClick}>
            <FormattedMessage id="wallet.statementItems.showMoreButton.text" values={{count: paginationCount}} />
          </ShowMoreButton>
        )}
      </>
    )
  }
}
